/**
 * כפתורי קטגוריות "חיפוש מהיר" לחבילות נופש (LDS FlightsHotel subjects).
 * מקור אחד לדשבורד הבית, לא למנוע החיפוש עצמו.
 */
export const PACKAGE_QUICK_CATEGORY_ITEMS = [
  { key: "ADULTS ONLY", label: "מבוגרים בלבד" },
  { key: "Attractions", label: "אטרקציות" },
  { key: "Cruise", label: "קרוז" },
  { key: "Football", label: "כדורגל" },
  { key: "HOTEL AND TOUR", label: "מלון וטיול" },
  { key: "Kosher", label: "כשר" },
  { key: "MASSORET", label: "מסורת" },
  { key: "Russian", label: "רוסית" },
  { key: "SHOP AND STORE", label: "קניות" },
  { key: "SKI KOSHER", label: "סקי כשר" },
  { key: "SPA MEDICAL", label: "ספא רפואי" },
  { key: "SHOW", label: "הופעות" },
  { key: "Ski", label: "סקי" },
  { key: "Spa", label: "ספא" },
  { key: "Sport", label: "ספורט" },
  { key: "Water Park", label: "פארק מים" },
  { key: "fashionTour", label: "טיול אופנה" },
];

export function filterVisiblePackageQuickCategories(subjectsFlightsHotel, items) {
  const available = subjectsFlightsHotel || [];
  return items.filter((c) =>
    available.some((a) => a?.toUpperCase() === c.key.toUpperCase())
  );
}

/** קודי LDS שלא מופיעים ככפתורי חיפוש מהיר, אבל כן מופיעים בדרופדאון. */
const PACKAGE_CATEGORY_LABEL_ALIASES = [
  { key: "INCLUDE BAGGAGE", label: "כולל כבודה" },
  { key: "INCLUDE TRANSFER", label: "כולל העברות" },
  { key: "FLIGHT ONLY", label: "טיסה בלבד" },
  { key: "FAMILY", label: "משפחות" },
  { key: "LOW COST", label: "לואו קוסט" },
  { key: "MINI TOUR", label: "מיני טור" },
  { key: "SPA AND WATERPARK", label: "ספא ופארק מים" },
  { key: "MEDICAL", label: "רפואי" },
];

/** תווית לתצוגה בדרופדאון תת־קטגוריה (עברית כשידוע, אחרת הקוד המקורי). */
export function getPackageCategoryDisplayLabel(category, allLabel = "הכל") {
  const raw = String(category ?? "").trim();
  if (!raw || raw.toUpperCase() === "ALL") return allLabel;
  const key = raw.toUpperCase();
  const hit =
    PACKAGE_QUICK_CATEGORY_ITEMS.find((c) => c.key.toUpperCase() === key) ||
    PACKAGE_CATEGORY_LABEL_ALIASES.find((c) => c.key.toUpperCase() === key);
  return hit?.label || raw;
}
